/**
 * Enum đã hạch toán
 * tvhien 19.09.2022
 */
export default {
  All: -1,
  UnPosted: 0,
  Posted: 1,
};
